import {Navigate} from 'react-router-dom';

/** Existing recovery tasks/bookmarks open the shared, currently authorized view. */
export function OverdueReturnsPage(){return <Navigate to="/phones-with-agents?status=OVERDUE" replace/>;}
